import React from "react";
import { FormattedMessage } from "react-intl";
import { Link as RouterLink } from "react-router-dom";
import { Stack as MuiStack } from "@mui/material";

import { formatEther } from "@framework/exchange";
import type { ICraft } from "@framework/types";
import { Card, List, Typography } from "@dzambalaorg/ui-kit";

import { AllowanceInfoPopover } from "../../../../../../components/dialogs/allowance";
import { CraftButton } from "../../../../../../components/buttons";

export interface ICraftItemPanelProps {
  craft: ICraft;
}

export const CraftItemPanel = (props: ICraftItemPanelProps) => {
  const { craft } = props;

  return (
    <Card>
      <Card.Content>
        <MuiStack direction="row" justifyContent="space-between">
          <Typography variant="h5" component="p">
            <FormattedMessage id="pages.recipes.ingredients" />
          </Typography>
          <AllowanceInfoPopover />
        </MuiStack>
        <List>
          {craft.price?.components.map((component, i) => (
            <List.ItemButton<typeof RouterLink>
              key={component.id || i}
              component={RouterLink}
              to={`/${component.tokenType.toLowerCase()}/templates/${component.templateId!}`}
            >
              <List.ItemText>
                {component.template!.title}{" "}
                {`(${formatEther(component.amount, component.contract!.decimals, component.contract!.symbol)}`})
              </List.ItemText>
            </List.ItemButton>
          ))}
        </List>
      </Card.Content>
      <Card.Footer>
        <CraftButton craft={craft} />
      </Card.Footer>
    </Card>
  );
};
